import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import download from './components/download';
import downloadTawi from './components/download5';
import SvgIcon from '@/components/SvgIcon';
import templateDownload from './components/template-download';
import OnJob from './components/on-job';
var maps = new Map([[1, {
  key: '1057',
  icon: 'download-c',
  state: 1
}], [2, {
  key: '1058',
  icon: 'tax',
  state: 2
}], [6, {
  key: '1481',
  icon: 'staff-info',
  state: 6
}], [8, {
  key: 'pnd3',
  icon: 'staff-info',
  state: 8
}], [5, {
  key: '1590',
  icon: 'staff-info',
  state: 5
}], [7, {
  key: '1860',
  icon: 'staff-info',
  state: 7
}], [4, {
  key: '1480',
  icon: 'staff-info',
  state: 4
}]
// 暂时去掉
// [3, { key: '1059', icon: 'staff-info', state: 3 }]
]);

export default {
  components: {
    download: download,
    downloadTawi: downloadTawi,
    SvgIcon: SvgIcon,
    templateDownload: templateDownload,
    OnJob: OnJob
  },
  data: function data() {
    return {
      isViewTemplateSetting: false,
      status: true,
      // 详情展示
      type: false,
      proveDatas: maps
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    theme: function theme(state) {
      return state.settings.themeColor;
    }
  })), {}, {
    sonTitle: function sonTitle() {
      var _maps$get;
      return this.$t(this.isViewTemplateSetting ? '1861' : ((_maps$get = maps.get(this.type)) === null || _maps$get === void 0 ? void 0 : _maps$get.key) || '');
    }
  }),
  methods: {
    handlerCloseTem: function handlerCloseTem() {
      this.isViewTemplateSetting = false;
      this.status = true;
    },
    // 模版配置开启
    handleOpenTemplateSetting: function handleOpenTemplateSetting() {
      this.status = false;
      this.isViewTemplateSetting = true;
    },
    // type 证明类型
    // status 是否关闭详情
    open: function open(type, status) {
      // 模版设置隐藏
      this.isViewTemplateSetting = false;
      this.status = status || false;
      type && (this.type = type);
    }
  }
};